var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneAnswerCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.007 16.003c0 6.008-4.985 11.002-11.005 11.002-6.01 0-11-4.994-11-11.002C5.002 9.983 9.982 5 15.992 5c6.02 0 11.015 4.983 11.015 11.003zm-4.83 4.83.078-.078c.606-.606.78-1.376.168-1.988-.454-.454-1.012-.964-2.195-1.597-.684-.369-1.161-.343-1.743.224l-.519.503c-.086.087-.197.102-.354.024-.36-.187-1.107-.714-1.96-1.567-.855-.855-1.38-1.6-1.566-1.96-.078-.156-.063-.267.023-.354l.504-.518c.559-.59.583-1.07.224-1.743-.636-1.186-1.144-1.74-1.598-2.195-.611-.612-1.382-.438-1.987.167l-.08.08c-2.17 2.17-.34 6.028 2.318 8.686 2.655 2.656 6.516 4.487 8.687 2.317z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAnswerCircle);
export default __webpack_public_path__ + "static/media/Phone_Answer-Circle.1e976c624b1129bbe9652d35c8a0113f.svg";
export { ForwardRef as ReactComponent };